export * from './version.component';

